/*
 |--------------------------------------------------------------------------
 | Avero Achmea API
 |--------------------------------------------------------------------------
 */

/* ========================================================================== *\
 IMPORTS
 \* ========================================================================== */

import calamiteiten from './calamiteiten/calamiteiten';

 /* == END IMPORTS =========================================================== */
 
 /* ========================================================================== *\
  CONSTANTS
  \* ========================================================================== */
 
 const
     /**
      * The module name
      * @type {String}
      */
     moduleName = 'api';
 
 /* == END CONSTANTS ========================================================= */
 
 /* ========================================================================== *\
  INITIALIZATION
  \* ========================================================================== */

window.AveroAchmeaApi = {};
window.AveroAchmeaApi.calamiteiten = calamiteiten;

 /* == END INITIALIZATION ==================================================== */
 